import { type RouteRecordRaw } from 'vue-router'

import { useStoresInformationsStore } from './storesInformations.store'

export const StoresInformationsRouter: RouteRecordRaw[] = [
  {
    path: '/store',
    component: async () => import('./StoresInformations.vue'),
    async beforeEnter() {
      await useStoresInformationsStore.getState().loadAppStore()
    },
  },
]
